import { withErrorBoundary } from "@sentry/react";

import ErrorFallback from "@components/error-fallback/error-fallback";
import IntegrationLogo, {
  IntegrationLogoType,
} from "@components/integration-logo/integration-logo";
import { classNames } from "@helpers/css";

const AskAIEmbedExternalEvent = ({
  eventType,
  eventData,
}: {
  eventType?: string;
  eventData?: any;
}) => {
  const linkClassName = "hover:underline font-medium";
  const source = eventType || "";
  return (
    <div className="flex gap-2 not-prose">
      <div className="mt-1 w-4 h-4">
        {source.startsWith("linear") ? (
          <IntegrationLogo
            type={IntegrationLogoType.Linear}
            className="block"
          />
        ) : source.startsWith("github") ? (
          <IntegrationLogo
            type={IntegrationLogoType.Github}
            className="block"
          />
        ) : source.startsWith("jira") ? (
          <IntegrationLogo type={IntegrationLogoType.Jira} className="block" />
        ) : source.startsWith("hubspot") ? (
          <IntegrationLogo
            type={IntegrationLogoType.Hubspot}
            className="block"
          />
        ) : (
          <IntegrationLogo
            type={IntegrationLogoType.Topicflow}
            className="block"
          />
        )}
      </div>
      <div className="flex-1">
        {eventData?.url && eventData?.title ? (
          <a
            href={eventData.url}
            target="_blank"
            rel="noreferrer"
            className={linkClassName}
          >
            {eventData.title}
          </a>
        ) : eventData?.title ? (
          <span className={classNames(linkClassName, "hover:no-underline")}>
            {eventData.title}
          </span>
        ) : (
          <div className="w-64 skeleton rounded-md h-6" />
        )}
      </div>
    </div>
  );
};

export default withErrorBoundary(AskAIEmbedExternalEvent, {
  fallback: ErrorFallback,
});
